export enum EmailListFooterStatus {
  AWAITING = 'awaiting',
  LOADING = 'loading',
  FAILED = 'failed',
  IDLE = 'idle',
  EXHAUSTED = 'exhausted',
}
